import { listingImageUrl } from './listingImageUrl';
import type { Listing } from '../api';

/** In-memory map of original listing image URL → already-loaded card display URL. */
const cardDisplayByOriginal = new Map<string, string>();

/** In-flight / resolved detail fetches started from card press (list → detail). */
const detailPrefetch = new Map<number, Promise<Listing>>();

export function rememberListingCardImage(originalUrl: string, displayUrl?: string) {
  const original = (originalUrl || '').trim();
  if (!original) return;
  const display = (displayUrl || listingImageUrl(original, 'card') || original).trim();
  if (!display) return;
  cardDisplayByOriginal.set(original, display);
}

export function getCachedListingCardImage(originalUrl: string | null | undefined): string {
  const original = (originalUrl || '').trim();
  if (!original) return '';
  return cardDisplayByOriginal.get(original) || listingImageUrl(original, 'card') || original;
}

export type ListingDetailNavState = {
  previewImageUrl?: string;
  /** Full card/list payload so detail can paint immediately. */
  listing?: Listing;
};

export function prefetchListingDetail(
  id: number,
  fetcher: (id: number) => Promise<Listing>,
): Promise<Listing> {
  const existing = detailPrefetch.get(id);
  if (existing) return existing;
  const p = fetcher(id)
    .then((data) => {
      detailPrefetch.set(id, Promise.resolve(data));
      return data;
    })
    .catch((err) => {
      detailPrefetch.delete(id);
      throw err;
    });
  detailPrefetch.set(id, p);
  return p;
}

export function takePrefetchedListingDetail(id: number): Promise<Listing> | null {
  return detailPrefetch.get(id) || null;
}
